// Public entry point. Mirrors the old js/src.js shape:
//   SALES.init({ api_endpoint, api_key })
// so existing embed sites only need to swap the bundle URL.

import * as salesLocator from './sales-locator.js';

const SALES = {
  init(options) {
    salesLocator.build(options);
  },
};

export default SALES;
